import { gql } from '@apollo/client';
import {
  ActivityFragment,
  LinkFragment,
  SourceFragment,
  ServiceFragment,
  FontsFragment,
  PodcastFragment,
  VideoFragment,
  AppsFragment,
} from './fragments';
import { DUPLICATED_FIELDS } from './getClientDetails.gql';

export default gql`
  ${SourceFragment}
  ${ActivityFragment}
  ${LinkFragment}
  ${ServiceFragment}
  ${FontsFragment}
  ${VideoFragment}
  ${PodcastFragment}
  ${AppsFragment}
  query ClientGroup($id: String!, $locale: String!) {
    clientGroup(
      id: $id
      locale: $locale
    ) {
        sys {
            id
          }
          formalShortName
          shortName
          ${DUPLICATED_FIELDS}
        }
  }
`;
